import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { SITE_BETA_DISCLAIMER_DISMISSED_KEY } from '../constants/siteDisclaimer';
import { useGaPageView } from '../useGaPageView';
import { BetaPriceNotice } from './BetaPriceNotice';
import { FeedbackFab } from './FeedbackFab';

function cx(...classes) {
  return classes.filter(Boolean).join(' ');
}

const FEEDBACK_LOCK_MS = 500;

function readBetaDisclaimerDismissed() {
  try {
    return localStorage.getItem(SITE_BETA_DISCLAIMER_DISMISSED_KEY) === '1';
  } catch {
    return false;
  }
}

export function AppShell() {
  const { pathname } = useLocation();
  const isHome = pathname === '/';
  const isPreLander = pathname === '/start';
  const isFocusedLanding = isHome || isPreLander;
  const [betaDisclaimerDismissed, setBetaDisclaimerDismissed] = useState(
    readBetaDisclaimerDismissed,
  );
  const [feedbackInteractionLocked, setFeedbackInteractionLocked] =
    useState(false);

  useGaPageView();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    if (!feedbackInteractionLocked) {
      return undefined;
    }
    const t = window.setTimeout(
      () => setFeedbackInteractionLocked(false),
      FEEDBACK_LOCK_MS,
    );
    return () => window.clearTimeout(t);
  }, [feedbackInteractionLocked]);

  return (
    <div className={cx('app', isFocusedLanding && 'app--home', isPreLander && 'app--pre-lander')}>
      <Outlet />
      {!isPreLander && (
        <BetaPriceNotice
          dismissed={betaDisclaimerDismissed}
          onDismiss={() => {
            setBetaDisclaimerDismissed(true);
            setFeedbackInteractionLocked(true);
            try {
              localStorage.setItem(SITE_BETA_DISCLAIMER_DISMISSED_KEY, '1');
            } catch {
              /* ignore */
            }
          }}
        />
      )}
      {!isPreLander && (
        <FeedbackFab
          betaNoticeVisible={!betaDisclaimerDismissed}
          interactionLocked={feedbackInteractionLocked}
        />
      )}
    </div>
  );
}
